import { wrapClassNames } from '@ui/utils/tailwind';
import type { FC } from 'react';

const loaderSizes = {
  sm: 'h-5',
  md: 'h-6',
  lg: 'h-7',
};

type LoaderSize = keyof typeof loaderSizes;

const loaderVariants = {
  danger: 'text-status-danger',
  default: 'text-neutral-800/60',
  white: 'text-white',
};

type LoaderVariant = keyof typeof loaderVariants;

const dotSizes = {
  sm: 'h-0.5 w-0.5',
  md: 'h-1.5 w-1.5',
  lg: 'h-3 w-3',
};

type DotSize = keyof typeof dotSizes;

export interface DotProps {
  size?: DotSize;
}

const StyledDot = ({ size = 'md' }: DotProps) => (
  <i
    className={wrapClassNames(`inline-block my-0 mx-0.5 rounded-full animate-pulse bg-current
    [&:nth-of-type(2)]:[animation-delay:_0.2s]
    [&:nth-of-type(3)]:[animation-delay:_0.4s]
    ${dotSizes[size]}`)}
  />
);

export interface LoaderProps {
  size?: LoaderSize;
  variant?: LoaderVariant;
  className?: string;
  'data-testid'?: string;
  tw?: never;
}

export const Loader: FC<LoaderProps> = ({ size = 'md', variant = 'default', className, ...props }) => (
  <div
    className={wrapClassNames(`relative inline-flex items-center w-full min-w-[2.25rem]
      ${loaderSizes[size]}
      ${loaderVariants[variant]}
      ${className ?? ''}
    `)}
    {...props}
  >
    <span className="absolute inset-0 flex items-center justify-center text-base select-none">
      <StyledDot size={size} />
      <StyledDot size={size} />
      <StyledDot size={size} />
    </span>
  </div>
);
